var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyHeroLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.296,
    height: 28,
    viewBox: "0 0 115.296 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.229,
    y1: 0.169,
    x2: 0.54,
    y2: 0.605,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc8e03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdf00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.231,
    y1: 0.356,
    x2: 0.998,
    y2: 0.689,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(-27.475 -222.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(55.011 229.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M197.654,264.909h-4v1.746h4a1.118,1.118,0,1,1,0,2.237h-4v5.727H195.4v-3.981h2.257a2.864,2.864,0,1,0,0-5.729Z",
    transform: "translate(-193.651 -264.909)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M248.609,267.8a2.868,2.868,0,0,0-2.865-2.864h-4v1.746h4a1.118,1.118,0,0,1,0,2.237h-4v1.746h3.577l1.449,3.981h1.858l-1.569-4.312A2.849,2.849,0,0,0,248.609,267.8Z",
    transform: "translate(-234.377 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 1.746,
    height: 9.71,
    transform: "translate(14.774 0.003)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M312,264.931l-2.592,7.121-2.592-7.121H304.96l3.534,9.712h1.83l3.535-9.712Z",
    transform: "translate(-287.913 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M352.521,264.931l-3.534,9.712h1.858l2.592-7.121,2.592,7.121h1.858l-3.535-9.712Z",
    transform: "translate(-325.197 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M408.167,266.68a3.093,3.093,0,0,1,2.119.835l.108.1,1.233-1.234-.113-.108a4.855,4.855,0,1,0,0,7.031l.113-.108-1.233-1.234-.108.1a3.109,3.109,0,1,1-2.119-5.383Z",
    transform: "translate(-371.203 -264.931)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M459.521,268.25l-2.291-3.319h-2.121l3.54,5.127v4.583h1.746v-4.583l3.54-5.127h-2.122Z",
    transform: "translate(-415.067 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M551.876,268.914h-3.948v-3.983h-1.745v9.71h1.745V270.66h3.948v3.981h1.746v-9.71h-1.746Z",
    transform: "translate(-492.193 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 6.867,
    height: 1.746,
    transform: "translate(62.742 0.003)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 6.867,
    height: 1.746,
    transform: "translate(62.742 7.967)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M618.372,267.8a2.868,2.868,0,0,0-2.865-2.864h-4v1.746h4a1.118,1.118,0,1,1,0,2.237H603.331v1.746h11.751l1.449,3.981h1.858l-1.569-4.312A2.848,2.848,0,0,0,618.372,267.8Z",
    transform: "translate(-540.589 -264.928)",
    fill: "#393a3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M708.14,264.931A4.855,4.855,0,1,0,713,269.785,4.86,4.86,0,0,0,708.14,264.931Zm3.109,4.855a3.109,3.109,0,1,1-3.109-3.109A3.112,3.112,0,0,1,711.249,269.786Z",
    transform: "translate(-625.236 -264.928)",
    fill: "#393a3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(27.475 222.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M93.2,240.283l.008,13.591-3.008,1.8v-4.6H86.7v10.745l9.9-5.851v-9.636l2.641,1.577v-4.06Z",
    transform: "translate(-77.627 -237.529)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M40.048,233.055v-9.71L38.291,222.3l-10.521,6.18-.295.174v4.037l2.641-1.568V250.3l3.4-2V229.161l3.026-1.769v5.662Z",
    transform: "translate(-27.475 -222.302)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyHeroLogo);
export default __webpack_public_path__ + "static/media/privacy-hero-logo.72e0bc2c04400386dc2a9136469cad25.svg";
export { ForwardRef as ReactComponent };